import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT US', path: '/about' },
    { name: 'DETAILING SERVICES', path: '/services' },
    { name: 'PAINT CORRECTION', path: '/paint-correction' },
    { name: 'CERAMIC COATING', path: '/ceramic-coating' },
    { name: 'BOOKING', path: '/booking' },
    { name: 'PRICING', path: '/pricing' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-zinc-900 text-white sticky top-0 z-50 border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/kingdom-logo.svg"
              alt="Kingdom Auto Detailing"
              className="h-16 w-auto"
            />
            <span className="text-xl font-bold text-amber-500 hidden md:inline">KINGDOM AUTO DETAILING</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex space-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-amber-500 ${
                  isActive(link.path) ? 'text-amber-500 border-b-2 border-amber-500 pb-1' : 'text-gray-300'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-md hover:bg-zinc-800 transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-zinc-800 border-t border-zinc-700">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'bg-amber-500 text-zinc-900'
                    : 'text-gray-300 hover:bg-zinc-700 hover:text-amber-500'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;